module.exports = __webpack_public_path__ + "img/guideline_3.135b585f.jpg";